import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {BrickSnake2000XWaysSymbol} from "./XWaysSymbol";
import {BrickSnake2000ScatterSymbol} from "./ScatterSymbol";
import {BrickSnake2000WildSymbol} from "./WildSymbol";
import {BrickSnake2000Symbol, SymbolArgs} from "./BrickSnake2000Symbol";
import {PaddingSymbol} from "./PaddingSymbol";
import {MaxWinSymbol} from "./MaxWinSymbol";
import {FreespinsMultiplierSymbol} from "./FreespinsMultiplierSymbol";
import {FreespinBlockerSymbol} from "./FreespinBlockerSymbol";
import {UpgradeSymbol} from "./UpgradeSymbol";
import {SlayerSymbol} from "./SlayerSymbol";
import {CollectorSymbol} from "./CollectorSymbol";
import {FreespinsEgg} from "./FreespinsEgg";

export class BrickSnake2000SymbolFactory {
    // might add spine and sprite pools later on

    constructor() {
    }

    // TODO make into a struct
    createSymbol(args:SymbolArgs):BrickSnake2000Symbol {
        let newSymbol:BrickSnake2000Symbol;
        switch(args.symbolName) {
            case "XW":
                newSymbol = new BrickSnake2000XWaysSymbol(args);
                break;
            case "S":
                newSymbol = new BrickSnake2000ScatterSymbol(args);
                break;
            case "W":
                newSymbol = new BrickSnake2000WildSymbol(args);
                break;
            case "P":
                newSymbol = new PaddingSymbol(args);
                break;
            case "MW":
            case "MA":
                newSymbol = new MaxWinSymbol(args);
                break
            case "X":
                newSymbol = new FreespinBlockerSymbol(args);
                break
            case "MU":
            case "WM":
                newSymbol = new FreespinsMultiplierSymbol(args);
                break
            case "UP":
                newSymbol = new UpgradeSymbol(args);
                break
            case "K":
                newSymbol = new SlayerSymbol(args);
                break
            case "TA":
                newSymbol = new CollectorSymbol(args);
                break
            case "SE":
                newSymbol = new FreespinsEgg(args);
                break
            case "SN":
                args.symbolName = "L1";
            default:
                newSymbol = new BrickSnake2000Symbol(args);
                break;

        }
        return newSymbol;
    }
}
